import { BaseUser } from "./baseUser";

export class User extends BaseUser {
    public email: string
    public role: User.Role;
    public permissions: User.Permissions;
    public status: User.Status;
    public serviceAreaIds: number[];
    public isAllowedAllServiceArea: boolean;
    public canCancelCalls: boolean;
    /**
     * Получение человекочитаемой строки "Право"
     */
    public GetHumanReadablePermissions(): string {
        if(this.permissions == User.Permissions.All)
        {
            return "Все";
        }
        else if(this.permissions == User.Permissions.None)
        {
            return "Права отсутствуют";
        }
        else if((this.permissions & User.Permissions.Write) == User.Permissions.Write)
        {
            return "Чтение и создание";
        }
        else if((this.permissions & User.Permissions.Read) == User.Permissions.Read)
        {
            return "Только чтение";
        }
        else
        {
            throw Error("Undefined permission");
        }
    }

    /**
     * Получение человекочитаемой строки "Статус"
     */
    public GetHumanReadableStatus(): string {
        switch (this.status) {
            case User.Status.Active:
                return "Активен";
            case User.Status.NotActive:
                return "Не активен";
            case User.Status.Locked:
                return "Заблокирован";
            default:
                throw Error("Undefined status");
        }
    }

  }

export namespace User {
    export class AccessData {
        constructor(
            public readonly accessToken: string,
            public readonly accessTokenValidTo: Date,

            public readonly serviceToken: string,
            public readonly serviceTokenValidTo: Date
        ) { }
    }

    export enum Role
    {
        Administrator,
        Manager
    }

    export enum Permissions
    {
        None = 0,
        Read = 1,
        Write = 2,
        All = ~None
    }

    export enum Status
    {
      NotActive = 0,
      Active = 1,
      Locked = 2
    }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/user.ts